import React from 'react';
import PropTypes from 'prop-types';

import CustomTypes from '../../../types';

import { FormCheckStyled } from './FormCheck.styled';

const FormCheck = ({ children, modifiers }) => (
  <FormCheckStyled modifiers={modifiers}>
    {children}
  </FormCheckStyled>
);

export default FormCheck;

FormCheck.propTypes = {
  children: PropTypes.node,
  modifiers: CustomTypes.oneOrMore(['', 'inline']),
};

FormCheck.defaultProps = {
  children: '',
  modifiers: '',
};
